import { useContext } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';

import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import { RolePlayInteractionMode } from 'redux/schemas/models/ai-role-play';
import { RootState } from 'redux/schemas';
import { config } from '../../../../../config/pendo.config.json';
import AiConversationContext, { AIRolePlayStatus } from './context';
import AvatarContainer from './avatar-container';
import ScenarioDetails from './scenario-details';
import { ClosingReason } from './stream-ai-response';

const ScenarioSection = () => {
  const {
    aiRolePlayStatus,
    showScenarioDetails,
    setShowScenarioDetails,
    interactionMode,
    sessionData,
  } = useContext(AiConversationContext);

  const submission = useSelector((state: RootState) => (
    sessionData.submissionId
      ? state.models.aiRolePlaySubmissions[sessionData.submissionId]
      : null
  ));

  const handleToggle = () => setShowScenarioDetails(!showScenarioDetails);

  return (
    <>
      {(interactionMode === RolePlayInteractionMode.TEXT
      || aiRolePlayStatus === AIRolePlayStatus.NOT_STARTED
      || submission?.closingReason === ClosingReason.COMPLETED)
        && <AvatarContainer />}
      {showScenarioDetails && <ScenarioDetails />}
      {(aiRolePlayStatus === AIRolePlayStatus.IN_PROGRESS
        || aiRolePlayStatus === AIRolePlayStatus.COMPLETED) && (
        <ClickableContainer
          className='mb-0 text-primary d-flex justify-content-center scenario-toggle-button text-small semi-bold'
          onClick={handleToggle}
          data-qa={config.pendo.activities.aiRolePlay.conversationModal.toggleScenario}
        >
          <NvIcon
            icon='gen-ai'
            size='xss-smallest'
            className='d-flex align-items-center'
          />
          <p className='mb-0 ml-1'>
            {showScenarioDetails
              ? t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.HIDE_SCENARIO()
              : t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.SHOW_SCENARIO()}
          </p>
        </ClickableContainer>
      )}
    </>
  );
};

export default ScenarioSection;
